const flagAircraft = (color) => {
    return `data:image/svg+xml;utf-8, \
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" height="50px" width="50px"><defs><style>.d{fill:${color};}</style></defs><g id="a"/><g id="b"><g id="c"><circle class="d" cx="16" cy="16" r="16"/></g></g></svg>`
}
export default flagAircraft

